import React from "react";
import "./Details_Banner.css";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight } from "@fortawesome/free-solid-svg-icons";

const Details_Banner = ({ image, name, subname, description }) => {
  const navigate = useNavigate();
  return (
    <section className="Details_Banner About_Banner">
      <div className="container-fluid">
        <div className="About_Banner_holder detail_banner">
          <div className='banner_holder'>
            <img src={image} className='banner' />
            {/* <img src='/assets/images/about-us/about_banner.png' className='banner' /> */}
          </div>


          <div className="name_holder">
            <h5 className="about_us">{name || ""} Tour</h5>
            <div className="breadcrumb_wrapper">
              <span className="breadcrumb_link" onClick={() => navigate("/")}>
                Home
              </span>
              <span className="breadcrumb_separator">
                {" "}
                <FontAwesomeIcon
                  icon={faAnglesRight}
                  style={{ color: "#fff", fontSize: "12px" }}
                />{" "}
              </span>
              <span className="breadcrumb_link" onClick={() => navigate(-1)}>
                Tour Packages
              </span>

              <span className="breadcrumb_separator">
                <FontAwesomeIcon
                  icon={faAnglesRight}
                  style={{ color: "#fff", fontSize: "12px" }}
                />{" "}
              </span>
              <span className="breadcrumb_active">Tour Details</span>
            </div>
          </div>


        </div>

        <div className="container">
          <div className="deatil_text_holder">
            <h5 className="deatil_title text-center">
              {subname || ""}            </h5>

            <p className="detail_desc">{description || ""} </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Details_Banner;
